import { Inject, Injectable } from '@angular/core';
import { ModalService } from './modal.service';
import { SignalService } from './signal.service';
import { Router } from '@angular/router';
import { GsapService } from './gsap.service';
import { AlertService } from './alert.service';

@Injectable({
  providedIn: 'root',
})
export class MasterService {

  constructor(private router: Router,
              private _svc_modal: ModalService, 
              private _svc_alert: AlertService,
              private _svc_signal: SignalService, 
              private gsap: GsapService
            ) 
  {  }
 
  navigate(p_destiny:string) {

    if (p_destiny.indexOf("modal-") >= 0) {
      if (p_destiny.indexOf("img-") >= 0) {
        this._svc_signal.setValue("modal-type", "modal-img");
        this.trg_modalimg(p_destiny.replace("modal-img-", ""));
      }
      else 
        this._svc_signal.setValue("modal-type", p_destiny); {
        this.trg_modal(p_destiny);
      }
    }
    else 
      switch(p_destiny) {
        
        case "language":
          this._svc_signal.setValue("header-language", false);
          break;

        case "newfight":
          window.open('https://academianewfight.com.br', '_blank') 
          break;

        case "portalize": 
          window.open('https://portalizebr.com.br', '_blank')
          break;

        case "vemmeteoro": 
          window.open('https://vemmeteoro.com.br', '_blank')
          break;

        case "close-all": 
          this.trg_master('close-all');
          break;

        default:
          this.trg_master('close-all');
          
          let l_redirect = ["outsourcing", "security"];

          let l_destiny = l_redirect.find(x => x == p_destiny) ? "studio" : p_destiny;

          this._svc_signal.setValue("compass", l_destiny);

          this.router.navigateByUrl(l_destiny); 
          
          this.gsap.anima_trg('scrolltop');
          break;
      }

  }

  trg_master(p_action:string):void {
    switch(p_action) {
      case "close-all":
        this._svc_modal.hide();
        this._svc_alert.hide();
        break;

      case "loading":
        this._svc_signal.setValue("loading", false);
        break;
    }
  }

  trg_sidedar(p_action: string) {
    this.gsap.anima_trg(p_action);
  }

  trg_modal(p_modal:string) {

    switch(p_modal) {

      case "modal-close":
        this._svc_modal.hide();
        break;

      case "modal-img": 
        
        this._svc_modal.show_img({ 
          title: 'IMG MODAL',
        });
        break;

      case "modal-talk": 
        
        this._svc_modal.show({ 
          title: 'FALE CONOSCO',
          msg: `
                Entraremos em contato dentro de 24hrs</b>`,
          img: 'assets/img/talk-fire-120.png',
          type: 'form'
        });
        break;
        
      case "modal-partners": 
        this._svc_modal.show({ 
          title: 'PARCERIAS',
          msg: `
              Juntos vamos mais longe<br/>
              <br/>`,
          img: 'assets/img/partners.png'
        });
        break;

      case "modal-joinus": 
        this._svc_modal.show({ 
          title: 'TRABALHE CONOSCO',
          msg: `
              Faça parte do nosso time<br/>
              <br/>`,
          img: 'assets/img/us-120.png'
        });
        break;

    }

  }

  trg_modalimg(p_img:string) {

    this._svc_modal.show_img({ 
      title: 'NOSSO ESPAÇO',
      msg: ``,
      img: 'assets/arena/arena00' + p_img + '.jpeg', 
      type: 'img'
    });

  }

}
